import { Link } from 'react-router'
import { useAuth } from '../app/auth-context'
import { Card } from '../components/ui'
import { ROLE_LABEL } from '../lib/staff-api'

export function HomePage() {
  const { staff } = useAuth()
  if (!staff) return null

  return (
    <div className="max-w-2xl">
      <h1 className="mb-6 text-2xl font-bold">سلام {staff.name}</h1>
      <Card>
        <p className="text-sm text-muted">
          با نقش «{ROLE_LABEL[staff.role]}» وارد شده‌اید. بخش کارتابل به‌زودی به این پیشخوان
          اضافه می‌شود.
        </p>
        <Link to="/customers" className="mt-4 me-6 inline-block text-sm font-semibold text-brand-600">
          جست‌وجوی مشتریان ←
        </Link>
        <Link to="/orders" className="mt-4 me-6 inline-block text-sm font-semibold text-brand-600">
          سفارش‌ها ←
        </Link>
        <Link to="/payments" className="mt-4 me-6 inline-block text-sm font-semibold text-brand-600">
          پرداخت‌ها ←
        </Link>
        {staff.role === 'ADMIN' ? (
          <Link to="/staff" className="mt-4 inline-block text-sm font-semibold text-brand-600">
            مدیریت کارکنان ←
          </Link>
        ) : null}
      </Card>
    </div>
  )
}
